import Language from "@/types/Models/Settings/Language";

const English: Language = {
    settings: {
        title: "Settings",
        theme: {
            title: "Theme",
            placeholder: "choose a theme",
            themes: {
                dark: "dark",
                light: "light",
            },
        },
        language: {
            title: "Language",
            placeholder: "choose a language",
        },
        mandant: {
            title: "Client",
            placeholder: "choose a client",
        },
        division: {
            title: "Division",
            placeholder: "not assigned",
        },
        logout: {
            title: "logout",
        },
        notifications: {
            saveSuccess: "Settings @:notifications.save.success",
            saveInfo: "",
            saveError: "Could not be saved, please try again",
            logout: "Successfully logged out",
        },
    },
    maintenance: {
        title: "Maintenance",
        description: "Please try again in a few minutes",
    },
    modules: {
        zew: {
            moduleDescription: {
                title: "Time management",
                fullTitle: "@:general.module @:modules.zew.moduleDescription.title",
            },
            currentTimeRecord: {loggedIn: "logged in since:", loggedOut: "logged out"},
            signIn: "sign in",
            signOut: "sign out",
            checkedIn: "logged in",
            checkedOut: "logged out",
            currently: "currently:",
            timeRecord: {
                hours: "hours", 
                saldo: "Balance", 
                holidaysSaldo: "holidays balance", 
                mutMessage: "Message",
                holidays: "holidays",
                sick: "sick",
                asOf: "as of",
            },
            absence: {
                name: "Absence | Absences",
                type: "Type",
                start: "Start date",
                end: "End date",
                message: "Description",
                hours: "Hours",
                entireDay: "All-day",
                supervisor: "Supervisor",
                create: "@:actions.create @:modules.zew.absence.name",
                overview: "Absence overview",
                form: {
                    dateRequired: "date required",
                    typeRequired: "type required",
                    endDateBeforeStartDate: "end date before start date",
                    descriptionRequired: "description required",
                    supervisorRequiredForVisa: "supervisor required for visa",
                    absenceCreateError: "absence could not be created",
                    absenceCreated: "absence created",
                    endTimeKnown: "end time known?",
                },
                states: {
                    requested: "@:modules.zew.absence.name requested",
                    approved: "@:modules.zew.absence.name approved",
                    rejected: "@:modules.zew.absence.name rejected",
                },
                request: {
                    messageRequired: "message required",
                    messageToLong: "message to long",
                    absenceApproved: "absence approved",
                    absenceRejected: "absence rejected",
                    absenceEdit: "edit absence",
                    overview: "overview",
                    createdBy: "created by",
                },
            },
            expense: {
                name: "Expense | Expenses",
                type: "Type",
                date: "Date",
                amount: "Amount",
                description: "Description",
                currency: "Currency",
                supervisor: "Supervisor",
                create: "@:actions.create @:modules.zew.expense.name",
                states: {
                    approved: "expense report approved",
                    rejected: "expense report rejected",
                    requested: "expense report requested",
                },
                form: {
                    dateRequired: "date required",
                    typeRequired: "type required",
                    expenseRequired: "expense required",
                    currencyRequired: "currency required",
                    descriptionRequired: "description required",
                    supervisorRequiredForVisa: "supervisor required for visa",
                    attachmentRequired: "attachment required",
                    absenceCreateError: "absence could not be created",
                    expenseReportCreateError: "expense report could not be created",
                    expenseReportCreated: "expense report created",
                    expenseReportNotCreated: "expense report not created",
                    expenseInvalid: "expense invalid",
                },
            },
        },
        todo: {
            moduleDescription: {
                title: "ToDo | ToDos",
                fullTitle: "@:general.module @:modules.todo.moduleDescription.title",
            },
            sortBy: {
                user: "User",
                company: "company",
                group: "team",
                dueDate: "due date",
                inDate: "creation date",
                status: "status",
                priority: "priority"
            },
            task: {
                title: "Task | Tasks",
                titleShort: "Task | Tasks",
                report: "report",
                finishReport: "close report",
                reportCacheCreated: "draft created",
                reportCacheSaved: "draft saved",
                draft: "draft",
                infoMessage: "Info / Process",
                errorMessage: "Error / Customer Message",
                assignedSybUser: "Assigned Person",
                secondaryUsers: "Secondary People",
                inSybUser: "ToDo Created By",
                assignedTitle: "Assignment",
                createTask: "@:actions.create @:modules.todo.task.title",
                taskSaved: "@:modules.todo.task.title saved",
                editTask: "@:actions.edit @:modules.todo.task.title",
                realStarttime: "actual start time:",
                realEndtime: "actual end time:",
                realTimeTotal: "actual hours:",
                roundedTimeTotal: "rounded hours:",
                entity: {
                    title: "Title",
                    comment: "Comment",
                    date: "Date",
                    hasTime: "Time known?",
                    startTime: "Start time",
                    endTime: "End time",
                    travel: "Travel",
                    hours: "hours",
                    billingType: "Billing type",
                    collaborators: "Additional employees"
                }
            },
            log: {
                customerInformation: "Customer Information",
                companyName: "Company, Name",
                companyAddress: "Address",
                deliveryAddress: "Delivery Address",
                contactInformation: "Contact Information",
                telP: "Private Phone:",
                telG: "Business Phone:",
                infiniteScrollLoading: "Loading more ToDos...",
                infiniteScrollEOF: "No more ToDos"
            },
            documents: {
                title: "Document | Documents",
                createDocument: "add document",
                selectDocument: "select document",
                entity: {
                    title: "Filename",
                    keywords: "keywords",
                    file: "file",
                },
                attachments: {
                    fileRequired: "File required",
                    attachmentRequired: "Attachment required"
                }
            },
            other: {
                todoCount: "ToDo Total: ",
                notDefined: "not defined",
                backToMonthlyOverview: "back to monthly overview",
            }
        }
    },
    general: {
        details: "Details",
        description: "Description",
        history: "History",
        module: "Module",
        date: "Date",
        start: "Begin",
        end: "End",
        download: "Download",
        time: {
            title: "Zeit",
            days: "day | days",
            hours: "hour | hours",
            timeSpent: "Time spent"
        },
        attachment: {
            title: "Attachment",
            preview: {
                title: "Preview",
                loading: "@:general.attachment.preview.title is loading...",
                error: "@:general.attachment.preview.title could not be loaded.",
            },
        },
    },
    transactions: {
        message: "message",
        inProgress: "in progress",
        approved: "approved",
        rejected: "rejected",
    },
    account: {
        welcomeBack: "welcome back",
        segments: {
            overview: "Overview",
            settings: "Settings",
        },
        user: {
            password: {
                reset: "reset password",
                new: "new password",
                repeat: "repeat password",
                lowerCaseRequired: "at least 1 lower case character",
                upperCaseRequired: "at least 1 upper case character",
                numberRequired: "at least 1 number",
                specialCharacterRequired: "at least 1 special character",
                minLengthRequired: "at least 8 characters",
                noMatch: "password does not match"
            },
        },
        login: {
            emailRequired: "Email required",
            emailInvalid: "Email invalid",
            passwordRequired: "Password required",
            noConnectionError: "Connection to server failed",
            wrongCredentialsError: "Email or password invalid",
            loginSubmit: "login",
            loginLoading: "Please wait...",
            contactSupport: "contact help desk",
            problem: "Problems?",
        },
    },
    actions: {
        exit: "close",
        back: "back",
        save: "save",
        cancel: "cancel",
        create: "create",
        read: "read",
        update: "update",
        edit: "edit",
        delete: "delete",
        select: "choose",
        search: "search",
        sortBy: "sort by:",
        orderByDescAsc: "descending / ascending",
        reject: "reject",
        accept: "accept",
        dismiss: "dismiss",
        complete: "complete",
        wait: "wait",
        confirm: "confirm",
        add: "add",
        reset: "reset",
        assign: "assign",
        download: "download",
    },
    admin: {
        roles: {
            title: "Role | Roles",
            cardTitle: "Role Management",
            editTitle: "Edit @:admin.roles.title",
            createTitle: "Create @:admin.roles.title",
            required: {
                nameRequired: "name is required",
                lengthRequired: "at least 3 characters required"
            },
            selectRole: {
                noRoleAvaiable: "No role avaible",
                createNewGroup: "Create new group",
            }
        },
        users: {
            title: "User | Users",
            cardTitle: "User Management",
            notifications: {
                success: "User @:notifications.save.success",
            },
            mandantUserForm: {
                maxUserRequired: "MaxUser is required",
                maxUserRequiredLength: "At least 2 characters",
                roleRequired: "Role is required",
            },
        },
        permissions: {
            title: "Permission | Permissions",
            deleteMessage: "All users that are part of this group, have to be reassigned to another group manually after delete. ",
            notifications: {
                success: "Permissions @:notifications.save.success",
            },
        },
        divisions: {
            title: "Division | Divisions",
            cardTitle: "Division Management",
            editTitle: "Edit @:admin.divisions.title",
            createTitle: "Create @:admin.divisions.title",
            notifications: {
                success: "Division @:notifications.save.success",
            },
            ccAbsences: {
                title: "CC absence report",
                helperText:
                    "Absence reports will be additionally sent to this E-Mail. \nChoose a person or enter an E-Mail address manually.",
                selectPerson: "@:actions.select a person",
            },
             required: "Level is required",
             helperText: "Example: Level 1 = Mitarbeitende, Level 2 = Vorgesetzte",       
        },
        general: {
            selectManager: "Responsible person from the HR.",
        },
    },
    notifications: {
        page: {
            title: "Message | Messages",
            noNotifications: "No Message",
        },
        entity: {
            markAsUnread: {
                title: "als ungelesen markieren",
                error: "Benachrichtigung konnte nicht als 'ungelesen' markiert werden",
                success: "Benachrichtigung wurde als ungelesen markiert",
            },
        },
        save: {
            success: "successfully saved",
            info: "",
            error: "could not be saved, please try again",
        },
        delete: {
            success: "successfully deleted",
            info: "",
            error: "could not be deleted please try again",
            errorDivision: "could not be deleted - users are already assigned!",
            question: "deletion confirm?",

        },
        update: {
            success: "successfully updated",
            denied: "This entry cannot be edited anymore",
            error: "could not be updated please try again",
        },
        app: {
            start: "Application is loading",
        },
        api: {
            connectionFailed: "Connection failed, try again later",
            connectionRestored: "Connection re-established...",
        },
        sync: {
            entity: {error: "Record not yet synchronized. <br/> Please try again in a few minutes"},
            module: {
                active: "Synchronizing, please try again later. <br/> start: {content}",
                inactive: "Max sync error: <br/> check the time management module",
            },
        },
        auth: {
            accessDenied: "Access denied",
        },
        google: {
            maps: {
                linkError: "The Google-Maps link could not be generated"
            }
        },
        download: {
            success: "successfully downloaded",
            error: "File could not be downloaded"
        }
    },
    form: {
        submit: {
            save: {
                waitText: "saving...",
            },
            delete: {
                waitText: "deleting...",
            },
            file: {
                notSupported: "This file type is not supported",
                imgTaken: "image taken successfully",
                cameraAccessDenied: "camera access denied",
                supportedFiles: "supported file types: ",
                saveImage: "save image",
                changeCamera: "change camera",
                camera: "camera",
            },
        },
        blocks: {
            customer: {
                name: "Name",
                namePlaceholder: "declare surname and lastname",
                street: "Street",
                streetPlaceholder: "declare street",
                location: "Location",
                locationPlaceholder: "declare location",
                contact: "contact",
                contactPlaceholder: "declare contact",
                phonePrivate: "private phone",
                phoneBusiness: "business phone",
                phonePlaceholder: "declare phone number",
                email: "E-Mail",
                emailPlaceholder: "declare E-Mail",
                deliveryAddress: "Delivery address",
                deliveryAddressPlaceholder: "declare delivery address",
            },
            image: {
                savedImage: "saved image",
                editEntry: "edit entry",
                addEntry: "add entry",
                close: "close",
                description: "description",
                save: "save",
            },
            invoice: {
                amount: "amount",
                amountPlaceholder: "enter amount",
                vat: "VAT rate",
                vatPlaceholder: "enter value in percent",
                sumTotal: "Sum total",
                sumTotalPlaceholder: "enter amount",
            },
            materials: {
                descriptionRequired: "description required",
                editEntry: "edit entry",
                addEntry: "add entry",
                close: "close",            
            },
            reportInformation: {
                reportNumber: "report number",
                customerNumber: "customer number",
                orderNumber: "order number",
                responsibleUser: "responsible user",
                date: "date",
                done: "save",
                cancel: "cancel",
            },
            settings: {
                sendCustomerCopy: "send copy to customer",
                addChecklistToCustomer: "Checkliste als Anhang mitsenden",
                customerMail: "E-Mail",
                customerMailPlaceholder: "declare E-Mail",
                customerMailError: "E-Mail invalid!",
            },
            tasks: {
                titleRequired: "title is required",
                titleMaxLengthError: "title is too long",
                dateRequired: "date is required",
                notANumber: "That's not a number",
                enterExpenseInHours: "Please specify the effort in hours",
                editEntry: "edit entry",
                addEntry: "add entry",
                close: "close",
                totalHours: "total hours",
            }
        }
        
    },
    tutorials: {
        title: "Instruction",
        overview: "Overview",
        admin: {
            roles: {
                overview: {
                    firstDescription: "",
                },
            },
            divisions: {
                overview: {
                    firstDescription: "",
                    secondDescription: "",
                },
            },
        },
    },
    alerts: {
        delete: {title: "Confirm delete", message: "Delete {content} ?"},
        reportDraft: {
            title: "Report in cache",
            message: "You still have a report in the cache - load the last edited version?",
            otherToDoTitle: "Report draft for a different ToDo",
            otherToDoMessage: "There is still an unfinished report draft cached for ToDo «{otherToDo}». Loading it switches to that ToDo. Discarding deletes the draft and you start a new report for «{currentToDo}»."
        }
    },
};

export default English;
